const DrawerActionType = {
  COLLAPSE_DRAWER: 'COLLAPSE_DRAWER',
  SET_CURRENT_CHALLENGE: 'SET_CURRENT_CHALLENGE',
  SET_AVAILABILITY_OBJECT: 'SET_AVAILABILITY_OBJECT',
  DRAWER_MOBILE_TOGGLE: 'DRAWER_MOBILE_TOGGLE',
  EXIT_VETSMITH: 'EXIT_VETSMITH'
}

export default DrawerActionType
